export const isValidEmail = (emailAddress: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailAddress);
};
